export default {
    flash(message, type = 'success') {
        this.$root.$emit('flash', { message, type })
        // Always scroll to top with smooth animation when showing flash messages
        this.scrollToTop(true)
    }
}